import React from "react";

const LogOutComponent = () => {
  return <div>LogOutComponent</div>;
};

export default LogOutComponent;
